'use client'

import styles from './Navbar.module.css'
import { FaInstagram, FaWhatsapp } from 'react-icons/fa6'
import Link from 'next/link'
import NextImage from 'next/image'
import { Anchor, Box, Button, Center, Group, Image } from '@mantine/core'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import BurgerMenu from './BurgerMenu'

const getWhatsappURL = (locale) => {
  const whattsappURL = new URL('https://api.whatsapp.com/send')
  whattsappURL.searchParams.append('phone', '584142287860')
  whattsappURL.searchParams.append('text', locale?.navbar?.whatsapp_message)
  whattsappURL.searchParams.append('type', 'phone_number')
  whattsappURL.searchParams.append('app_absent', '0')

  return whattsappURL.href
}

export function NavBar({ burger = true, lang = 'en', locale }) {
  const pathName = usePathname()
  const [showWsButton, setShowWsButton] = useState(false)

  useEffect(() => {
    setShowWsButton(pathName.includes('catalog'))
  }, [pathName])

  return (
    <Box>
      <nav className={styles.navbar}>
        <div className={styles.logoContainer}>
          <Center h={48}>
            <Link href={`/${lang}`}>
              <Image
                h={42}
                w={96}
                height={42}
                width={96}
                className={styles.logo}
                component={NextImage}
                src="/logo.webp"
                alt="Logo"
              />
            </Link>
          </Center>
        </div>
        {burger ? (
          <div className={styles.iconsContainer}>
            <Group align="center" justify="center" wrap="nowrap">
              {showWsButton ? (
                <Button
                  className={styles.wsButton}
                  component="a"
                  target="_blank"
                  href={getWhatsappURL(locale)}
                >
                  <p className={styles.wsText}>{locale?.navbar?.whatsapp_support}</p>
                  <FaWhatsapp className={styles.wsIcon} />
                </Button>
              ) : undefined}

              <Anchor
                href="https://www.instagram.com/redi.siempre/#"
                target="_blank"
                rel="instagram"
              >
                <Center>
                  <FaInstagram color="#ffffff" className={styles.instagram} />
                </Center>
              </Anchor>
              <BurgerMenu lang={lang} locale={locale} />
            </Group>
          </div>
        ) : undefined}
      </nav>
    </Box>
  )
}
